/**
 * Warranty / Accountability (sections/warranty-trust.liquid): on phones the cards are a peeking slider (CSS). This adds
 * one dot per card (like the Customer Videos slider), keeps the dot on the centred card, and tapping a dot centres
 * exactly that card. Dot labels use the card titles, so there is no fixed text here.
 */
(() => {
  if (customElements.get('wty-warranty-trust')) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class WtyWarrantyTrust extends HTMLElement {
    connectedCallback() {
      this.row = this.querySelector('.wty__cards');
      this.dotsWrap = this.querySelector('[data-wty-dots]');
      if (!this.row || !this.dotsWrap) return;
      this.cards = Array.from(this.row.querySelectorAll('.wty__card'));
      this.dotsWrap.replaceChildren();
      this.dots = this.cards.map((card, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'wty__dot';
        const title = card.querySelector('.wty__card-title')?.textContent.trim();
        dot.setAttribute('aria-label', `${i + 1} / ${this.cards.length}${title ? `: ${title}` : ''}`);
        dot.addEventListener('click', () => this.centre(i));
        this.dotsWrap.appendChild(dot);
        return dot;
      });
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      this.row.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();
    }

    centre(i) {
      const card = this.cards[i];
      const rowBox = this.row.getBoundingClientRect();
      const box = card.getBoundingClientRect();
      const left = this.row.scrollLeft + box.left - rowBox.left - (rowBox.width - box.width) / 2;
      this.row.scrollTo({ left, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }

    update() {
      const rowBox = this.row.getBoundingClientRect();
      const middle = rowBox.left + rowBox.width / 2;
      let active = 0;
      let best = Infinity;
      this.cards.forEach((card, i) => {
        const box = card.getBoundingClientRect();
        const distance = Math.abs(box.left + box.width / 2 - middle);
        if (distance < best) {
          best = distance;
          active = i;
        }
      });
      this.dots.forEach((dot, i) => (i === active ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current')));
    }
  }

  customElements.define('wty-warranty-trust', WtyWarrantyTrust);
})();
